import { GOAL_ACHIEVE_LIMITS } from "shared/CalculatorLimits";
import { GOAL_ACHIEVE_REASONS } from "shared/CalculatorReasons";
import { SavingsCalculator } from "web_myplann/Calculators/Components/SavingsCalculator";
import { GOAL_ACHIEVE_YEARS_DEFAULT } from "web_myplann/Calculators/constants";
import { CalculatorType } from "web_myplann/Calculators/Types/CalculatorType";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const GoalAchieveCalculatorPage = () => {
	const { t } = useResource();

	return (
		<SavingsCalculator
			type={CalculatorType.GoalAchieve}
			reasonLabel={t(Resources.Calculators.Savings.GoalReason)}
			reasons={GOAL_ACHIEVE_REASONS}
			reasonNode={Resources.Calculators.Savings.GoalReasons}
			yearsMin={GOAL_ACHIEVE_LIMITS.yearsMin}
			yearsMax={GOAL_ACHIEVE_LIMITS.yearsMax}
			yearsDefault={GOAL_ACHIEVE_YEARS_DEFAULT}
		/>
	);
};
